import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { CalculatingResponsiveness } from './components/CalculatingResponsiveness';
import { useDmScoreData } from './hooks/useDmScoreData';

export const ResponsivenessScore: React.FC = () => {
	const {
		data: { scoreTag, responsivenessScore },
	} = useDmScoreData();

	if (responsivenessScore === null || !scoreTag) return null;

	return (
		<div className="w-full lg:relative lg:mt-8 lg:w-[343px] xl:w-[496px]" data-testid="dm-responsiveness-score">
			<div
				className={cn(
					'bg-surface-neutral text-content-primary flex w-full flex-col items-center rounded-lg p-4',
					'lg:absolute lg:top-0 lg:right-0 lg:z-20',
					'shadow-[0px_10px_20px_#18191F20]',
				)}
				style={{ border: `2px solid ${scoreTag.labelColor}` }}
			>
				<Text role="heading" aria-level={2}>
					Petition response rate: {responsivenessScore}%
				</Text>
				<div
					className="my-2 rounded-full px-4 py-2 text-lg font-semibold"
					style={{ backgroundColor: scoreTag.labelColor, color: scoreTag.textColor }}
				>
					{scoreTag.label}
				</div>
				<CalculatingResponsiveness />
			</div>
		</div>
	);
};
